import { apiClient } from "./client";

export type MfaStatus = { enabled: boolean };

export type EnrollBeginResponse = {
  secret: string;
  provisioning_uri: string;
  qr_png_data_url: string;
};

export async function getMfaStatus(): Promise<MfaStatus> {
  const { data } = await apiClient.get<MfaStatus>("/api/v1/me/mfa");
  return data;
}

export async function enrollBegin(): Promise<EnrollBeginResponse> {
  const { data } = await apiClient.post<EnrollBeginResponse>(
    "/api/v1/me/mfa/enroll-begin",
  );
  return data;
}

export async function enrollConfirm(code: string): Promise<MfaStatus> {
  const { data } = await apiClient.post<MfaStatus>(
    "/api/v1/me/mfa/enroll-confirm",
    { code },
  );
  return data;
}

export async function disableMfa(password: string, code: string): Promise<MfaStatus> {
  const { data } = await apiClient.post<MfaStatus>("/api/v1/me/mfa/disable", {
    password,
    code,
  });
  return data;
}
